import { useContext } from 'react';
import { GroupEntityTagsUpdateContext } from '@trinity/chat-components/contexts/group-tags/index.js';

export default function useGroupEntityTagsUpdate() {
  const value = useContext(GroupEntityTagsUpdateContext);
  return value;
}

export { useGroupEntityTagsUpdate };